// component d-upload-file by yongbodi · di
import { Component, Vue, Prop } from 'vue-property-decorator'
import { uploadFile } from '@/api/common'

@Component({
    name: 'dUploadFile'
})
export default class DUploadFile extends Vue {

    // 上传文件的地址，如果有就用，如果没有就用计算属性 {uploadUrl}
    @Prop({ default: '', type: String }) private url?: string
    // 是否显示文件列表
    @Prop({ default: false, type: Boolean }) private fileListShow?: boolean
    // 文件列表
    @Prop({ default: () => ([]), type: Array }) private fileList?: { url: string; name: string }[]
    // 文件大小 单位 MB 
    @Prop({ default: undefined, type: Number }) private fileSize?: number
    // 文件是否可以多选 
    @Prop({ default: false, type: Boolean }) private multiple?: boolean
    // 点击文件列表是否可以查看详情
    @Prop({ default: false, type: Boolean }) private fileInfo?: boolean
    // 是否禁用
    @Prop({ default: false, type: Boolean }) private disabled?: boolean
    // 是否可以删除
    @Prop({ default: true, type: Boolean }) private isDelete?: boolean

    // 上传地址
    get uploadUrl() {
        let url = ''
        if(process.env.NODE_ENV === 'development') {
            url = process.env.VUE_APP_BASE_CRM_API_PROXY + '/uploadFile'
        } else {
            if(window.location.origin.includes('-testserver')) {
                url = process.env.VUE_APP_DEV_API + 'uploadFile'
            } else {
                url = process.env.VUE_APP_MASTER_API + 'uploadFile'
            }
        }
        return url
    }

    // 生成 type=file 的 input 然后触发点击事件选择文件
    choiceFile() {
        if(this.disabled) return 
        const inputDom = document.createElement('input')
        inputDom.style.opacity = '0'
        inputDom.type = 'file'
        // 根据 props 决定有哪些功能
        inputDom.multiple = this.multiple
        inputDom.click()
        // 选择文件之后触发change事件
        inputDom.onchange = () => {
            let files: any[] = [...inputDom.files]
            files = files
            .map(item => {
                const formData = new FormData()
                if(this.fileSize) {
                    // 限制文件大小
                    if(item.size / 1024 / 1024 > this.fileSize) {
                        return undefined
                    } else {
                        formData.append('file', item)
                    }
                } else {
                    formData.append('file', item)
                }
                return formData
            })
            .filter(item => item)
            this.uploadFile(files)
        }
    }

    async uploadFile(files: FormData[]) {
        for(let i = 0; i < files.length; i++) {
            // 当遇到后台报错的时候阻止后续上传
            const { name, ossUrl } = await uploadFile(files[i]) as unknown as { name: string; ossUrl: string }
            this.fileList.push({ name, url: ossUrl })
            this.$emit('update:fileList', this.fileList)
        }
        this.$message.success('上传成功')
    }

    delFile(index: number) {
        this.fileList.splice(index, 1)
        this.$emit('update:fileList', this.fileList)
    }

}